<template>
  <div style="overflow: hidden; margin-top: -1.8rem">
    <div>
      <router-link
        class="btn btn-info m-2"
        :to="`/dashboard/agent-Business-Account`"
      >
        Back to All KYC
      </router-link>

      <card class="card">
        <button class="section-button" @click="toggleSection('business')">
          Business Account
        </button>
        <div>
          <form @submit.prevent="submitAgent">
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Business Name"
                  placeholder="Business Name"
                  v-model="agent.businessName"
                  required
                >
                </fg-input>
                <span v-if="!agent.businessName && submitted" class="text-danger">Business Name is required</span>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="email"
                  label="Business Email"
                  placeholder="Business Email"
                  v-model="agent.businessEmail"
                  required
                >
                </fg-input>
                <span v-if="!isValidEmail(agent.businessEmail) && submitted" class="text-danger">Invalid Email</span>
              </div>
              <div class="col-md-4">
                <label>Merchant Name</label>
                <multiselect
                  v-model="selectedMerchant"
                  :custom-label="optionLabel"
                  track-by="_id"
                  :options="utils.merchants"
                  :allow-empty="false"
                  placeholder="Select a Merchant"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    {{ option.merchantName }}
                  </template>
                </multiselect>
                <span v-if="!selectedMerchant && submitted" class="text-danger">Merchant is required</span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Phone Number"
                  placeholder="Phone Number"
                  v-model="agent.phoneNumber"
                  required
                >
                </fg-input>
                <span v-if="!isValidPhoneNumber(agent.phoneNumber) && submitted" class="text-danger">Phone Number must be 11 digits</span>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Business Address"
                  placeholder="Business Address"
                  v-model="agent.businessAddress"
                  required
                >
                </fg-input>
                <span v-if="!agent.businessAddress && submitted" class="text-danger">Business Address is required</span>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Industry"
                  placeholder="Industry"
                  v-model="agent.industry"
                  required
                >
                </fg-input>
                <span v-if="!agent.industry && submitted" class="text-danger">Industry is required</span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="businessCategory">Business Category</label>
                  <select
                    id="businessCategory"
                    class="form-control"
                    v-model="agent.businessCategory"
                    required
                  >
                    <option value="" disabled>Select Business Category</option>
                    <option
                      v-for="category in businessCategories"
                      :key="category"
                      :value="category"
                    >
                      {{ category }}
                    </option>
                  </select>
                  <span v-if="!agent.businessCategory && submitted" class="text-danger">Business Category is required</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="businessIndustry">Business Industry</label>
                  <select
                    id="businessIndustry"
                    class="form-control"
                    v-model="agent.businessIndustry"
                    required
                  >
                    <option value="" disabled>Select Business Industry</option>

                    <option v-for="x in businessIndustries" :key="x" :value="x">
                      {{ x }}
                    </option>
                  </select>
                  <span v-if="!agent.businessIndustry && submitted" class="text-danger">Business Industry is required</span>
                </div>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Nationality"
                  placeholder="Nationality"
                  v-model="agent.nationality"
                  required
                >
                </fg-input>
                <span v-if="!agent.nationality && submitted" class="text-danger">Nationality is required</span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="businessState">Business State</label>
                  <select
                    id="businessState"
                    class="form-control"
                    v-model="agent.businessState"
                    @change="fetchLgas"
                    required
                  >
                    <option value="" disabled>Select Business State</option>
                    <option
                      v-for="state in utils.allStates"
                      :key="state"
                      :value="state"
                    >
                      {{ state }}
                    </option>
                  </select>
                  <span v-if="!agent.businessState && submitted" class="text-danger">Business State is required</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="localGovernment">Local Government</label>
                  <select
                    id="localGovernment"
                    class="form-control"
                    v-model="agent.localGovernment"
                    required
                  >
                    <option value="" disabled>Select Local Government</option>
                    <option
                      v-for="lga in utils.lgas"
                      :key="lga.id"
                      :value="lga.name"
                    >
                      {{ lga.name }}
                    </option>
                  </select>
                  <span v-if="!agent.localGovernment && submitted" class="text-danger">Local Government is required</span>
                  <span v-if="utils.lgaLoading">Fetching LGA's...</span>
                </div>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Account Type"
                  placeholder="Account Type"
                  :value="accountTypeDisplay"
                  disabled
                >
                </fg-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="RC Number"
                  placeholder="RC Number"
                  v-model="agent.rcNumber"
                  required
                >
                </fg-input>
                <span v-if="!agent.rcNumber && submitted" class="text-danger">RC Number is required</span>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  label="Tax Identification Number"
                  placeholder="Tax Identification Number"
                  v-model="agent.tin"
                  required
                >
                </fg-input>
                <span v-if="!agent.tin && submitted" class="text-danger">Tax Identification Number is required</span>
              </div>
            </div>

            <div class="text-center" style="padding: 10px">
              <p-button type="info" round @click.native.prevent="submitAgent">
                <div
                  class="spinner-grow"
                  role="status"
                  v-if="loading.show"
                ></div>
                Submit
              </p-button>
            </div>
          </form>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      agent: {
        businessName: "",
        businessEmail: "",
        contactPerson: "",
        phoneNumber: "",
        businessAddress: "",
        industry: "",
        businessCategory: "",
        businessType: "",
        nationality: "",
        businessState: "",
        localGovernment: "",
        merchantId: "",
        state: "",
        accountType: "business-account",
        rcNumber: "",
        tin: "",
      },
      selectedMerchant: "",
      businessIndustries: [
        "Retail",
        "Wholesale",
        "Manufacturing",
        "Services",
        "ICT",
      ],
      businessCategories: [
        "sole-proprietor",
        "private-limited-liability-company",
        "public-limited-liability-company",
        "non-governmental-organization",
        "government",
      ],
      lgas: [],
      loading: {
        show: false,
      },
      submitted: false,
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
    accountTypeDisplay() {
      return "Business Account";
    },
  },
  methods: {
    ...mapActions([
      "getStates",
      "getLgas",
      "getCountries",
      "setLoading",
      "setNotification",
      "getMerchants",
    ]),
    isValidEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.[^<>()[\]\.,;:\s@"]{2,}))$/i;
      return re.test(String(email).toLowerCase());
    },
    isValidPhoneNumber(phoneNumber) {
      return phoneNumber.length === 11 && /^[0-9]+$/.test(phoneNumber);
    },
    submitAgent() {
      this.submitted = true;
      if (
        this.agent.businessName &&
        this.isValidEmail(this.agent.businessEmail) &&
        this.selectedMerchant &&
        this.isValidPhoneNumber(this.agent.phoneNumber) &&
        this.agent.businessAddress &&
        this.agent.industry &&
        this.agent.businessCategory &&
        this.agent.businessIndustry &&
        this.agent.nationality &&
        this.agent.businessState &&
        this.agent.localGovernment &&
        this.agent.rcNumber &&
        this.agent.tin
      ) {
        this.loading.show = true;
        setTimeout(() => {
          this.loading.show = false;
          // Show SweetAlert notification
          Swal.fire({
            title: "KYC Completed!",
            text: "Click OK to view details.",
            icon: "success",
            confirmButtonText: "OK",
            showCancelButton: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push(`/agent-details/${this.agent.id}`);
            }
          });
        }, 2000);
      } else {
        Swal.fire({
          title: "Form Incomplete",
          text: "Please fill in all required fields correctly.",
          icon: "error",
          confirmButtonText: "OK",
          showCancelButton: false,
        });
      }
    },
    optionLabel({ merchantName, state, country }) {
      return `${merchantName}, ${state}, ${country}`;
    },
    fetchLgas() {
      this.agent.localGovernment = "";
      this.getLgas(this.agent.businessState).then((lgas) => {
        this.lgas = lgas;
      });
    },
    getAgents() {
      this.getAllMerchantAgents({ merchantId: this.selectedMerchant._id });
    },
  },
  mounted() {
    this.getMerchants();
    this.getStates().then((states) => {
      this.utils.allStates = states;
    });
  },
};
</script>

<style scoped>
.section-button {
  background: none;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
  color: #000;
  position: relative;
  text-decoration: none;
}

.section-button::after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: transparent;
  transition: all 0.3s ease;
}

.section-button:hover::after {
  width: 100%;
  background-color: #c35800;
}

.section-button::after {
  width: 100%;
  background-color: #00c307;
}
</style>
